import Vue from 'vue'

/**
 * @author José Luis R.
 * @param id Casualty's id
 * @return {Array}
 */

export default ({ id }) =>
  Vue.$http.put(`sinister/affected/set_verified_data/${id}/`)
    .then(response => response.data)
